import { render, staticRenderFns } from "./my-camera1.vue?vue&type=template&id=8ac751f8&scoped=true&"
import script from "./my-camera1.vue?vue&type=script&lang=js&"
export * from "./my-camera1.vue?vue&type=script&lang=js&"
import style0 from "./my-camera1.vue?vue&type=style&index=0&id=8ac751f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac751f8",
  null
  
)

export default component.exports